import React from 'react'
import BottomSheet from '.'

import ShareIcon from '../../assets/icons/upload-doc/share.svg'
import UploadIcon from '../../assets/icons/upload-doc/upload-again.svg'
import EditIcon from '../../assets/icons/upload-doc/edit.svg'
import ChevronRight from '../Icons/ChevronRight'
import postMessageToRN, {
  SHARE_FILE,
} from '../../utils/helpers/ReactNativeEvents'
import Text from '../Text'

const MoreOptionsBottomSheet = ({
  show,
  onClose,
  onUploadAgainClick,
  document,
  showUploadAgain = false,
}) => {
  const handleShareClick = () => {
    const payload = {
      documentLink: document?.documentLink,
      documentName: document?.documentName,
    }
    postMessageToRN(SHARE_FILE, payload)
  }

  return (
    <>
      <BottomSheet show={show} title="More Options" onClose={onClose}>
        <ul>
          <li>
            <button
              className="flex items-center justify-between px-5 py-2 w-full border-b border-gray-200"
              onClick={() => handleShareClick()}
            >
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-[#EADDFF] flex items-center justify-center">
                  <img src={ShareIcon} className="w-5 h-5" alt="Share" />
                </div>
                <Text variant="body" size="medium" tag="p">
                  Share File
                </Text>
              </div>
              <ChevronRight />
            </button>
          </li>
          <li>
            {showUploadAgain && (
              <button
                className="flex items-center justify-between px-5 py-2 w-full border-b border-gray-200"
                onClick={onUploadAgainClick}
              >
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-[#EADDFF] flex items-center justify-center">
                    <img src={UploadIcon} className="w-5 h-5" alt="Upload" />
                  </div>
                  <Text variant="body" size="medium" tag="p">
                    Upload again
                  </Text>
                </div>
                <ChevronRight />
              </button>
            )}
          </li>
        </ul>
      </BottomSheet>
    </>
  )
}

export default MoreOptionsBottomSheet
